/**
 * Collapses the long parts of a product description into an accordion.
 *
 * The descriptions are pasted from PDFs, so their markup is inconsistent —
 * markers like "INCI:", "MODO D'USO" and "PRINCIPI ATTIVI" appear as plain text
 * inside <p>/<span>, not as headings. Rather than parse that HTML, this walks
 * the description the browser has already rendered and regroups the top-level
 * blocks by marker.
 *
 * Safe by construction: a description with no recognised marker is left exactly
 * as it is, and if this script never runs the full text is still readable.
 */
(function () {
  'use strict';

  // order matters: longest / most specific first
  var SECTIONS = [
    { key: 'inci',    label: 'Ingredienti (INCI)', open: false, test: /^\s*INCI\b/i },
    { key: 'uso',     label: "Modo d'uso",         open: true,  test: /^\s*MODO\s*D\s*[''’`]?\s*USO/i },
    { key: 'attivi',  label: 'Principi attivi',    open: true,  test: /^\s*PRINCIPI\s+ATTIVI/i }
  ];

  function textOf(el) {
    return (el.textContent || '').replace(/ /g, ' ').trim();
  }

  function matchMarker(el) {
    var t = textOf(el);
    if (!t) return null;
    for (var i = 0; i < SECTIONS.length; i++) {
      if (SECTIONS[i].test.test(t)) return SECTIONS[i];
    }
    return null;
  }

  function build(container) {
    // flatten the PDF-paste wrappers so top-level blocks are actually siblings
    var wrappers = container.querySelectorAll('div.page, div.layoutArea, div.column');
    Array.prototype.forEach.call(wrappers, function (w) {
      while (w.firstChild) w.parentNode.insertBefore(w.firstChild, w);
      w.parentNode.removeChild(w);
    });

    var blocks = Array.prototype.slice.call(container.children);
    var groups = [];
    var current = null;

    blocks.forEach(function (el) {
      var marker = matchMarker(el);
      if (marker) {
        current = { spec: marker, nodes: [el] };
        groups.push(current);
      } else if (current) {
        current.nodes.push(el);
      }
    });

    if (!groups.length) return false; // nothing recognised — leave it alone

    var acc = document.createElement('div');
    acc.className = 'pd-accordion';

    groups.forEach(function (group, index) {
      var id = 'pd-panel-' + group.spec.key + '-' + index;

      var item = document.createElement('div');
      item.className = 'pd-accordion__item';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'pd-accordion__trigger';
      trigger.setAttribute('aria-expanded', group.spec.open ? 'true' : 'false');
      trigger.setAttribute('aria-controls', id);
      trigger.appendChild(document.createTextNode(group.spec.label));

      var icon = document.createElement('span');
      icon.className = 'pd-accordion__icon';
      icon.setAttribute('aria-hidden', 'true');
      trigger.appendChild(icon);

      var panel = document.createElement('div');
      panel.className = 'pd-accordion__panel pd-accordion__panel--' + group.spec.key + ' rte';
      panel.id = id;
      panel.hidden = !group.spec.open;

      // first node is the marker line itself — the label replaces it
      group.nodes.forEach(function (node, i) {
        if (i === 0) {
          var rest = textOf(node).replace(group.spec.test, '').replace(/^[:\s]+/, '');
          if (rest) {
            var p = document.createElement('p');
            p.textContent = rest;
            panel.appendChild(p);
          }
          node.parentNode.removeChild(node);
          return;
        }
        panel.appendChild(node);
      });

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });

      item.appendChild(trigger);
      item.appendChild(panel);
      acc.appendChild(item);
    });

    container.appendChild(acc);
    return true;
  }

  function init() {
    var containers = document.querySelectorAll('[data-product-description]');
    Array.prototype.forEach.call(containers, function (c) {
      try {
        build(c);
      } catch (e) {
        /* a broken description must never break the page */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
